import Grid from '@highcharts/grid-lite/es-modules/masters/grid-lite.src.js';

const metrics = [
    {
        name: 'Efficiency',
        definition: 'Number of parking fines issued by one guard per month',
        normalization: '↑ min-max observed (0–14.3 fines/guard/month)',
        max: 200,
    },
    {
        name: 'Leniency',
        definition: 'Share of warnings in total parking interventions (fines + warnings)',
        normalization: '↓ thresholds: ≤10% = max, ≥50% = 0 pts – guards issuing fines in fewer than half of interventions are scored lower',
        max: 100,
    },
    {
        name: 'Wheel Clamps',
        definition: 'Number of wheel clamps applied per guard per month',
        normalization: '↑ min-max observed (0–6.8 clamps/guard/month)',
        max: 100,
    },
    {
        name: 'Towing',
        definition: 'Number of non-wreck tows per 100k residents per year',
        normalization: '↑ min-max observed (0–798 tows/100k)',
        max: 100,
    },
    {
        name: 'Pedestrian crossing towing',
        definition: 'Number of tows for creating a hazard (e.g. blocking pedestrian crossings) per 100k residents per year',
        normalization: '↑ min-max observed (0–18.1 tows/100k)',
        max: 100,
    },
    {
        name: 'Wreck towing',
        definition: 'Number of wreck tows per 100k residents per year',
        normalization: '↑ min-max observed (0–88 wrecks/100k)',
        max: 100,
    },
    {
        name: 'Civic cooperation',
        definition: 'Share of citizen reports (from the response-time system) closed by the guard',
        normalization: '↑ thresholds: 0% = 0 pts, 100% = max (natural boundary)',
        max: 100,
    },
    {
        name: 'Unfairness',
        definition: 'Ratio of total additional fees imposed by the SPP operator to the value of illegal-parking fines issued by the guard',
        normalization: '↓ thresholds: ≤0.3× = max, ≥3× = 0 pts; cities without SPP data receive 0 pts',
        max: 100,
    },
    {
        name: 'Guards',
        definition: 'Number of guard posts per 100k residents',
        normalization: '↑ min-max observed (10–68 guards/100k)',
        max: 100,
    },
    {
        name: 'Budget',
        definition: 'Annual guard budget divided by number of residents',
        normalization: '↑ thresholds: ≤10 PLN/resident = 0 pts, ≥140 PLN/resident = max',
        max: 50,
    },
    {
        name: 'Traffic fines share',
        definition: 'Share of illegal-parking fines in the total number of fines issued',
        normalization: '↓ thresholds: ≤50% = max, ≥80% = 0 pts – guards focused almost exclusively on parking are scored lower',
        max: 50,
    },
    {
        name: 'Fine cost',
        definition: 'Annual guard budget divided by total number of fines issued',
        normalization: '↓ thresholds: ≤794 PLN/fine = max, ≥3\u00a0000 PLN/fine = 0 pts',
        max: 50,
    },
    {
        name: 'Salary',
        definition: 'Median gross salary of guards; units without data receive the minimum observed value',
        normalization: '↑ min-max observed (4\u00a0900–9\u00a0792 PLN gross)',
        max: 50,
    },
];

export default function gridMetodologia(id) {
    if (!document.getElementById(id)) return;

    Grid.grid(id, {
        dataTable: {
            columns: {
                'Metric': metrics.map(m => m.name),
                'Definition': metrics.map(m => m.definition),
                'Normalisation': metrics.map(m => m.normalization),
                'Max\u00a0pts': metrics.map(m => m.max),
            }
        },
        rendering: {
            rows: { strictHeights: false },
            theme: 'hcg-theme-default theme-compact'
        },
        columns: [
            { id: 'Metric', cells: { className: 'bold' }, width: 160 },
            { id: 'Definition' },
            { id: 'Normalisation' },
            { id: 'Max\u00a0pts', cells: { className: 'cell-right' }, width: 70 },
        ]
    });
}
